import { Profile } from '@src/user/models/account'
import { MessageDescriptor } from 'react-intl'

export enum AccountActionType {
  LOGIN = '@Account/LOGIN',
  BEFORE_LOGIN = '@Account/BEFORE_LOGIN',

  LOGOUT = '@Account/LOGOUT',
  LOGOUT_SUCCESS = '@Account/LOGOUT_SUCCESS',
  LOGOUT_ERROR = '@Account/LOGOUT_ERROR',

  UNAUTHORIZED = '@AccountUNAUTHORIZED',

  GET_PROFILE = '@Account/GET_PROFILE',
  GET_PROFILE_SUCCESS = '@Account/GET_PROFILE_SUCCESS',
  GET_PROFILE_ERROR = '@Account/GET_PROFILE_ERROR',
}

export const beforeLoginAction = (payload: string) => ({
  type: AccountActionType.BEFORE_LOGIN,
  payload,
})

export const loginAction = (payload: string) => ({
  type: AccountActionType.LOGIN,
  payload,
})

export const logoutAction = () => ({
  type: AccountActionType.LOGOUT,
})

export const logoutSuccessAction = () => ({
  type: AccountActionType.LOGOUT_SUCCESS,
})

export const logoutErrorAction = () => ({
  type: AccountActionType.LOGOUT_ERROR,
})

export const unauthorizedAction = (payload: MessageDescriptor) => ({
  type: AccountActionType.UNAUTHORIZED,
  payload,
})

export const getProfileAction = () => ({
  type: AccountActionType.GET_PROFILE,
})

export const getProfileSuccessAction = (payload: Profile) => ({
  type: AccountActionType.GET_PROFILE_SUCCESS,
  payload,
})

export const getProfileErrorAction = (error?: any) => ({
  type: AccountActionType.GET_PROFILE_ERROR,
  error,
})
